<template>
  <div class="site-map">
    <h1>{{ $t('siteMap.page') }}</h1>
    <div class="container">
      <div class="site-map-group" v-for="item in data.page">
        <h2>{{ item.title }}</h2>
        <a :href="sitePageUrl(subItem.url)" class="link" v-for="subItem in item.page">{{ subItem.title }}</a>
      </div>
    </div>
  </div>

  <div class="site-map">
    <h1>{{ $t('siteMap.sort') }}</h1>
    <div class="container">
      <div class="site-map-group" v-for="item in data.categoryInfo">
        <NuxtLinkLocale :to="searchUrl(item.url)" class="link">{{ item.title }}</NuxtLinkLocale>
      </div>
    </div>
  </div>

  <div class="site-map">
    <h1>{{ $t('siteMap.keywords') }}</h1>
    <div class="container">
      <div class="site-map-group" v-for="item in data.keywordInfo">
        <NuxtLinkLocale :to="searchUrl(item.url)" class="link">{{ item.title }}</NuxtLinkLocale>
      </div>
    </div>
  </div>
</template>

<script setup>
import { routeConstMapping } from '@/utils/routes_mapping.js'
defineI18nRoute({
  paths: {
  }
})

const { t, locale } = useI18n();

const searchUrl = (url) => {
  return url.replace(/\s+/g, '-')
}

const sitePageUrl = (path) => {
  let p = path
  if (locale.value == 'en') {
    return p;
  }
  if (p !== '/' && p.endsWith('/')) {
    p = p.substr(0, p.length - 1);
  }
  let key = '';
  for (const routeKey of Object.keys(routeConstMapping['en'])) {
    const routePath = routeConstMapping['en'][routeKey];
    if (routePath === p) {
      key = routeKey;
      break;
    }
  }
  return routeConstMapping[locale.value][key];
};

const query = {
  language: locale.value,
}
const data = ref()
try {
  const siteData = await useGetSitemapList(query)
  data.value = siteData.data
} catch (error) {

}
</script>

<style scoped lang="scss">
.site-map {
  @include flexColumn(start);

  @include responseTo(pc-700px) {
    max-width: 1200px;
    min-width: 700px;
    width: 100%;
    margin: 30px auto;
    padding: 40px;
  }

  @include responseTo(web-699px) {
    max-width: 350px;
    padding: 0 13px;
    margin: 30px auto;
  }
}

h1 {
  font-family: SFPro, SFPro;
  font-weight: bold;
  color: #000000;
  text-align: left;
  font-style: normal;

  @include responseTo(pc-700px) {
    font-size: 30px;
    margin-bottom: 30px;
  }

  @include responseTo(web-699px) {
    font-size: 20px;
    margin-bottom: 20px;
  }
}

h2 {
  font-family:
    SFPro,
    PingFang SC,
    Hiragino Sans GB,
    Microsoft YaHei,
    Arial,
    sans-serif;
  font-weight: bold;
  color: #1d1d20;
  line-height: 24px;
  text-align: left;
  font-style: normal;
}

.link {
  font-family:
    SFPro,
    PingFang SC,
    Hiragino Sans GB,
    Microsoft YaHei,
    Arial,
    sans-serif;
  font-weight: medium;
  color: #707177;
  line-height: 19px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.container {
  @include responseTo(pc-700px) {
    @include flex(space-between);
    flex-wrap: wrap;
    width: 100%;
    justify-content: start;
    i {
      width: 25%;
    }
  }

  @include responseTo(web-699px) {
    @include flex(space-between);
    flex-wrap: wrap;
    width: 100%;
    justify-content: start;
    i {
      display: none
    }
  }
}

.site-map-group {
  word-wrap: break-word;
  text-overflow: ellipsis;
  @include responseTo(pc-700px) {
    @include flexColumn(space-between);
    justify-content: start;
    width: 25%;

    h2 {
      font-size: 20px;
      margin-bottom: 16px;
    }

    .link {
      font-size: 16px;
      line-height: 19px;
      margin-bottom: 16px;
      margin-right: 16px;
    }
  }

  @include responseTo(web-699px) {
    @include flexColumn(start);
    width: calc(50% - 10px);
    margin-right: 10px;

    h2 {
      font-size: 16px;
      margin-bottom: 16px;
    }

    .link {
      font-size: 14px;
      line-height: 16px;
      margin-bottom: 16px;
      margin-right: 20px;
    }
  }
}
</style>
